import { Button, Result } from "antd";
import { useTranslation } from "react-i18next";
export function CancelledState(props: { onReapply: () => void }) {
  const { t } = useTranslation();
  return (
    <Result
      status="info"
      title={t("clientEmptyState.cancelledTitle")}
      extra={<Button type="primary" onClick={props.onReapply}>{t("clientEducationDetail.cta.reapplyAfterCancel")}</Button>}
    />
  );
}
